import React from "react";

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogImage,
  canonical 
}) => {
  // Default fallbacks
  const siteTitle = title || "Mobile Bar Service & Rental | Mélange Mobile Bar";
  const siteDescription = description || "Professional mobile bartending services for your special events. Bartending That Comes To You.";
  const siteKeywords = keywords || "mobile bar, bartending service, event bartending, mobile bartender, bar rental";
  const siteUrl = typeof window !== 'undefined' ? window.location.href : '';
  const canonicalUrl = canonical || siteUrl;

  // React 19 natively supports rendering meta tags in components
  return (
    <>
      {/* Basic Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      {siteKeywords && <meta name="keywords" content={siteKeywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph Tags */}
      <meta property="og:type" content="website" />
      {siteUrl && <meta property="og:url" content={siteUrl} />}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </>
  );
};

export default SEO;
